var map = {
	"./cost/routes.js": "8ab4",
	"./customer/routes.js": "12fd",
	"./equipment/routes.js": "4490",
	"./product/routes.js": "b148",
	"./quotation/routes.js": "9d76",
	"./sample/routes.js": "f294",
	"./service/routes.js": "e1de",
	"./settings/routes.js": "de76",
	"./user/routes.js": "2e02"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "74855";